import router from "@/router";
import store from "@/store";

export default {
  data() {
    return {
      Roles: {
        Admin: "Admin",
        User: "User",
        Guest: "Guest",
        CompanyAdmin: "CompanyAdmin",
        SuperAdmin: "SuperAdmin",

        AdminOrUser: ["Admin", "CompanyAdmin", "SuperAdmin"],
        CompanyOrUser: ["Admin", "CompanyAdmin", "User", "SuperAdmin"],
        AdminOrCompanyAdmin: ["Admin", "CompanyAdmin", "SuperAdmin"],
        AdminOrSuper: ["Admin", "SuperAdmin"]
      }
    };
  },

  methods: {
    allowed(route, roles = null) {
      var role = store.state.users.currentUser.role;

      var allowed = false;

      if (route !== null) {
        if (route.charAt(0) === "/") {
          route = route.substring(1, route.length);
        }

        var routeArr = route.split("/");

        if (routeArr.length > 0) {
          router.options.routes.forEach(e => {
            if (e.path === "/" + routeArr[0]) {
              if (e.children) {
                e.children.forEach(c => {
                  if (c.path === routeArr[1]) {
                    if (c.meta) {
                      if (!c.meta.authorize) allowed = true;

                      allowed = c.meta.authorize.includes(role);
                    }
                  }
                });
              }
            }
          });
        }
      } else if (roles !== null) {
        allowed = roles.includes(role);
      }

      return allowed;
    },

    // Check if the user is allowed to be edited by the current user
    allowedToEdit(role, targetRole) {
      let allowed = false;

      if (role === this.Roles.Admin || role === this.Roles.SuperAdmin) {
        allowed = targetRole !== this.Roles.Admin && this.Roles.SuperAdmin;
      }

      if (role === this.Roles.CompanyAdmin) {
        allowed =
          targetRole !== this.Roles.Admin &&
          targetRole !== this.Roles.SuperAdmin &&
          targetRole !== this.Roles.CompanyAdmin;
      }

      return allowed;
    },

    // The roles needs to be an array
    authorize(roles) {
      let role = store.state.users.currentUser.role;
      if (role === this.Roles.Admin || role === this.Roles.SuperAdmin) {
        return true;
      }

      return roles.includes(role);
    }
  }
};
